import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/conditions.svg',
})
export class ConditionsComponent {}
